<template>
  <div class="clock">
      <div class="number" v-for="n in 12" :key="n" :style="positionNumber(n)">{{ n }}</div>
      <div class="hand hour-hand" :style="{ transform: `rotate(${hourDegree}deg)` }"></div>
      <div class="hand minute-hand" :style="{ transform: `rotate(${minuteDegree}deg)` }"></div>
      <div class="hand second-hand" :style="{ transform: `rotate(${secondDegree}deg)` }"></div>
      <div class="center-circle"></div>
  </div>
</template>

<script>
export default {
  data() {
      return {
          hourDegree: 0,
          minuteDegree: 0,
          secondDegree: 0
      };
  },
  methods: {
    updateTime() {
    const now = new Date();
    
    const seconds = now.getSeconds();
    const minutes = now.getMinutes();
    const hours = now.getHours();

    this.secondDegree = (seconds * 6); // 360 degrees/60 secs = 6 degrees per second
    this.minuteDegree = (minutes * 6) + (seconds * 0.1); // 360 degrees/60 mins = 6 degrees per minute + fractional movement due to seconds
    this.hourDegree = (hours % 12 * 30) + (minutes * 0.5); // 360 degrees/12 hours = 30 degrees per hour + fractional movement due to minutes
},
      positionNumber(n) {
          const angle = (n-3) * (Math.PI/6);
          const distanceFromCenter = 45; // Reduced distance for numbers
          const x = 50 + distanceFromCenter * Math.cos(angle) + '%';
          const y = 50 + distanceFromCenter * Math.sin(angle) + '%';

          return {
              left: `calc(${x} - 10px)`, // 10px offset to center the number
              top: `calc(${y} - 10px)` 
          };
      }
  },
  mounted() {
      setInterval(this.updateTime, 1000);
      this.updateTime();
  }
}
</script>

<style>
.clock {
  position: relative;
  width: 300px;
  height: 300px;
  border: 7px solid #333;
  border-radius: 50%;
  margin: 0 auto;
}

.number {
  position: absolute;
  width: 20px;
  height: 20px;
  font-size: 16px;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
  color: #333;
}

.hand {
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform-origin: 50% 100%;
  transform: rotate(90deg);
  z-index: 1;
}

.hour-hand {
  width: 8px;
  height: 100px;
  background: #333;
  margin-left: -4px;
}

.minute-hand {
  width: 6px;
  height: 130px;
  background: #666;
  margin-left: -3px;
}

.second-hand {
  width: 4px;
  height: 140px;
  background: #ff0000;
  margin-left: -2px;
}

.center-circle {
  position: absolute;
  width: 16px;
  height: 16px;
  background: #333;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
</style>
